import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cookie-footer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Om cookies", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "separator" }, "|", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Privatlivspolitik", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkComponent = _resolveComponent("LinkComponent")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
			'cookie-container',
			{ 'cookie-footer--themed': _ctx.isThemed },
			{ 'cookie-footer--app': _ctx.isLoggedInAsApp() },
		])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_LinkComponent, {
        to: "https://www.almbrand.dk/kundeservice/generel-information/cookies/",
        target: "_blank",
        class: "cookie-footer__link",
        externalIcon: true,
        smallIcon: true,
        alternateIcon: true
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _hoisted_3,
      _createVNode(_component_LinkComponent, {
        to: "https://www.almbrand.dk/kundeservice/generel-information/privatlivspolitik/",
        target: "_blank",
        class: "cookie-footer__link",
        externalIcon: true,
        smallIcon: true,
        alternateIcon: true
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ])
  ], 2))
}